<template>
  <div>
    <Toolbar >
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-strategy</v-icon>{{$t('profile.strategy.qualities')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-profilestrategyquality-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.strategy.quality') }}</strong></td>
              <td>
                                    {{ item['quality'].name }}
              </td>

              <td><strong>{{ $t('profile.strategy.part') }}</strong></td>
              <td>
                                    {{ item['part'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.strategy.infill') }}</strong></td>
              <td>
                                    {{ item['infill'] }}
              </td>

              <td><strong>{{ $t('profile.strategy.support') }}</strong></td>
              <td>
                                    {{ item['support'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.strategy.denseSupport') }}</strong></td>
              <td>
                                    {{ item['denseSupport'] }}
              </td>

              <td><strong>{{ $t('profile.strategy.skirt') }}</strong></td>
              <td>
                                    {{ item['skirt'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.strategy.raft') }}</strong></td>
              <td>
                                    {{ item['raft'] }}
              </td>

              <td><strong>{{ $t('profile.strategy.primepillar') }}</strong></td>
              <td>
                                    {{ item['primePillar'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.strategy.oozeshield') }}</strong></td>
              <td>
                                    {{ item['oozeShield'] }}
              </td>

            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'ProfileStrategyQuality';

export default {
  name: 'ProfileStrategyQualityShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {

    ...mapGetters('profilestrategyquality', ['find']),
    ...mapFields('profilestrategyquality', {
      isLoading: 'isLoading'
    }),
  },
  methods: {
    ...mapActions('profilestrategyquality', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
